import { getUser } from "../../auth"
import NoteUI from "../components/NoteUI";

const URL = process.env.REACT_APP_API_URL;

export default function Note({ note, rol }) {
  const handleDelete = () => {
    const user = getUser();
    fetch(`${URL}/api/notes/${note.id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "X-Empresa-Id": user?.empresa_id
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Error al eliminar la nota");
        return res.json();
      })
      .catch((error) => console.error(error));
  };

  return (
    <NoteUI
      note={note}
      rol={rol}
      onDelete={handleDelete}
    />
  )
}
